export enum HonourTypes {
    Equal  = 1,
    GreaterThan = 2,
    GreaterThanOrEqual = 3,
    LessThan = 4,
    LessThanOrEuqal = 5
}
